import { InputFieldData, InputStateProps } from '../../@types/input-field-data';
import TextInput from './text-input';

export interface FullNameInputProps extends InputStateProps, InputFieldData {
  type: 'full_name';
}

/** A component for rendering an input to collect the user's full name. */
function FullNameInput(props: FullNameInputProps) {
  return (
    <TextInput
      {...props}
      maxLength={40}
      name={props.name || 'full_name'}
      text={props.text || 'Full Name'}
      type="text"
    />
  );
}

export default FullNameInput;
